/**
 * Created by guga on 8/1/2016.
 */

import { RefreshToken } from './refresh-token';

export class Token {
    public expiration   : number;
    public expired      : boolean;
    public expiresIn    : number;
    public refreshToken : RefreshToken;
    public scope        : string[];
    public tokenType    : string;
    public value        : string;
};


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas-models/token.ts